<form [formGroup]="accountForm">
  <div class="form-row">
    <div class="col-md-12 m-b-20">
      <div class="row pt-lg-3">
        <div class="col-12 col-md-12 col-lg-12 col-sm-12">
          <span class="note font-16 d-none d-lg-block d-md-block d-xl-block">
            {{translationScope+'.instructions.bank_account_form.stripe_payment_instruction' | transloco}}
            <br /><br />
            {{translationScope+'.instructions.bank_account_form.iban_number_instruction_pre_link_text' | transloco}}
            <a href="https://www.iban.co.no/calculate-iban" target="“_blank”" style="cursor: pointer"><b>
              {{translationScope+'.instructions.bank_account_form.iban_number_instruction_link_text' | transloco}} </b></a>
              {{translationScope+'.instructions.bank_account_form.iban_number_instruction_post_link_text' | transloco}}.
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="col-md-12 col-lg-12 col-sm-12">
      <div class="input-item-edit required">
        <label for="type-experience" class="text-uppercase">{{translationScope+'.form.account_holder_name.label' | transloco}}
        </label>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-10">
            <input type="text" formControlName="account_holder_name" class="form-control rounded-0"
              [class.form-control-error]="isInvalidateControl('account_holder_name', 'required')"
              [placeholder]="translationScope+'.form.account_holder_name.placeholder' | transloco"
              required />
            <span *ngIf="isInvalidateControl('account_holder_name', 'required')" class="form-control-error-message" >
              {{translationScope+'.form.account_holder_name.error.required' | transloco}}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="input-item-edit required">
        <label for="type-experience" class="text-uppercase">
          {{translationScope+'.form.iban.label' | transloco}}
        </label>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-10">
            <input type="text" formControlName="account_number" class="form-control rounded-0"
              [class.form-control-error]="isInvalidateControl('account_number', 'required')" [placeholder]="translationScope+'.form.iban.placeholder' | transloco"  required />
            <span *ngIf="isInvalidateControl('account_number', 'required')" class="form-control-error-message" >{{translationScope+'.form.iban.error.required' | transloco}}</span>
            <span *ngIf="isInvalidateControl('account_number', 'iban')" class="form-control-error-message" >{{translationScope+'.form.iban.error.invalid' | transloco}}</span>
          </div>
        </div>
      </div>
    </div>


  </div>
  <div *ngIf="!isTabReadOnly" class="row btn-control-group mt-5">
    <div class="col-6 col-sm-12 col-md-6">
      <button (click)="Back()" class="btn btn-success form-control rounded-0" >
        {{translationScope+'.action_buttons.back' | transloco}}
      </button>
    </div>
    <div class="col-6 col-sm-12 col-md-6">
      <button [disabled]="accountForm.invalid && !isUpdate" (click)="formSubmit()" class="btn btn-success form-control rounded-0" >
        {{translationScope+'.action_buttons.next' | transloco}}
      </button>
     <!--  <button *ngIf="isUpdate" (click)="next()" class="btn btn-success form-control rounded-0" >
        {{translationScope+'.action_buttons.next' | transloco}}
      </button> -->
    </div>
  </div>
</form>
